<template>
  <div id="app">
    <div class="wrap" v-if="is_login">
      <el-container>
        <el-header class="layer-header" height="60px">
          <Header></Header>
        </el-header>
        <el-container class="layer-wrap">
          <el-aside width="180px" class="layer-menu" v-if="user.login_type=='admin'">
            <Menu></Menu>
          </el-aside>
          <el-main class="layer-main">
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-container>
    </div>
    <div class="" v-if="!is_login">
      <router-view></router-view>
    </div>
  </div>
</template>

<style>
@import "assets/global.scss";
@import "assets/iconfont.css";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  background: #ffffff;
  /*flex: 1;*/
}
body,html{padding:0;margin: 0;}
img{display: block;}
.layer-header { position: fixed; z-index: 10; left: 0; right: 0; top: 0; height: 60px; line-height: 60px; display:
    flex; background: #5dbb85; color: #fff;}
.layer-wrap { position: fixed; z-index: 10; left: 0; right: 0; top: 60px; bottom: 0; background: #ffffff; display:
    flex; }
.layer-menu { background: #E4E7ED; }
.layer-main { overflow-x: hidden; overflow-y: auto; padding: 0 !important; margin: 20px;position: relative;}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: rgba(240, 240, 240, 1);
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 0px rgba(240, 240, 240, .5);
  border-radius: 10px;
  background-color: rgba(240, 240, 240, .5);
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 0px rgba(240, 240, 240, .5);
  background-color: #5dbb85;
}

</style>
<script>
import Header from "@/components/header";
import Menu from "@/components/menu";
export default {
  components: {Header,Menu},
  data(){
    return{

    }
  }
}

</script>
